// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NM9L","toggleWrap":"styles_toggleWrap__1xaie","content":"styles_content__161m8","selectAreaCode":"styles_selectAreaCode__3foq2"};